import createIcon from '../../createIcon';

/**
 * @component @name WbShade
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgMTJWMTQuNUwxOS41IDIwSDIyTDE0IDEyWk0xNCAyMEgxN0wxNCAxN1YyMFpNOCA0TDIgMTBINFYyMEgxMlYxMEgxNEw4IDRaTTkgMTRIN1YxMEg5VjE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WbShade = createIcon('WbShade', [
  [
    'path',
    {
      d: 'M14 12V14.5L19.5 20H22L14 12ZM14 20H17L14 17V20ZM8 4L2 10H4V20H12V10H14L8 4ZM9 14H7V10H9V14Z',
      key: 'hp3uij',
    },
  ],
]);

export default WbShade;
